import { HaulLabel } from 'common/models/harvestData/hauler';
import { useMemo } from 'react';
import { Column } from 'react-table';
import {
  CenteredHeader,
  CenteredText,
} from '../components/Sub-views/RatesView/Tabs/styles';

export type RangesTableRows = {
  range: string;
};

export const useRangesTableData: {
  (rows: HaulLabel[]): {
    columns: Column<RangesTableRows>[];
    data: RangesTableRows[];
  };
} = rows => {
  const columns: Column<RangesTableRows>[] = useMemo(
    () => [
      {
        Header: () => <CenteredHeader>Range</CenteredHeader>,
        accessor: 'range',
        Cell: ({ value }) => <CenteredText>{value}</CenteredText>,
      },
    ],
    [],
  );

  const data: RangesTableRows[] = useMemo(
    () => rows.map(row => ({ range: `${row.miles} miles` })),
    [rows],
  );

  return {
    columns,
    data,
  };
};
